import { BonusView } from "./bonus-view";
export function registerViewers(){
    BonusView.registerElement();
}